import React from 'react';
import { InvoiceItem, calculateItemTotal, calculateItemVat, formatCurrency } from '../models/invoice';

interface Props {
    items: InvoiceItem[];
    onItemChange: (index: number, field: string, value: string | number) => void;
    onAddItem: () => void;
    onRemoveItem: (index: number) => void;
    dataTestId?: string;
}

const InvoiceItems: React.FC<Props> = ({ items, onItemChange, onAddItem, onRemoveItem, dataTestId = "invoice-items" }) => {
    const handleInput = (index: number, field: keyof InvoiceItem, value: string) => {
        let parsedValue: string | number = value;

        if (field === 'quantity' || field === 'price' || field === 'vat') {
            parsedValue = parseFloat(value) || 0;
        }

        onItemChange(index, field, parsedValue);
    };

    return (
        <div style={styles.container} data-testid={dataTestId}>
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={{ ...styles.th, ...styles.colName }}>Pavadinimas</th>
                        <th style={{ ...styles.th, ...styles.colUnit }}>Vnt.</th>
                        <th style={{ ...styles.th, ...styles.colQty }}>Kiekis</th>
                        <th style={{ ...styles.th, ...styles.colPrice }}>Kaina (€)</th>
                        <th style={{ ...styles.th, ...styles.colVat }}>PVM (%)</th>
                        <th style={{ ...styles.th, ...styles.colTotal }}>Suma</th>
                        <th style={{ ...styles.th, ...styles.colAction }}></th>
                    </tr>
                </thead>
                <tbody data-testid="invoice-items-body">
                    {items.map((item, index) => (
                        <tr key={item.id}>
                            <td style={styles.td}>
                                <input
                                    type="text"
                                    value={item.name}
                                    onChange={(e) => handleInput(index, 'name', e.target.value)}
                                    placeholder="Paslauga"
                                    style={styles.input}
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="text"
                                    value={item.unit}
                                    onChange={(e) => handleInput(index, 'unit', e.target.value)}
                                    placeholder="vnt."
                                    style={styles.input}
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={item.quantity}
                                    onChange={(e) => handleInput(index, 'quantity', e.target.value)}
                                    style={styles.input}
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={item.price}
                                    onChange={(e) => handleInput(index, 'price', e.target.value)}
                                    style={styles.input}
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="number"
                                    step="1"
                                    value={item.vat}
                                    onChange={(e) => handleInput(index, 'vat', e.target.value)}
                                    style={styles.input}
                                />
                            </td>
                            <td style={{ ...styles.td, ...styles.colTotal }}>
                                {formatCurrency(calculateItemTotal(item) + calculateItemVat(item))}
                            </td>
                            <td style={{ ...styles.td, ...styles.colAction }}>
                                <button
                                    style={styles.btnRemove}
                                    onClick={() => onRemoveItem(index)}
                                    title="Pašalinti eilutę"
                                    data-testid={`remove-item-${index}`}
                                >
                                    ×
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button style={styles.btnAdd} onClick={onAddItem} data-testid="add-item">
                + Pridėti eilutę
            </button>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'block',
        overflowX: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        minWidth: '600px',
    },
    th: {
        textAlign: 'left',
        padding: '10px',
        backgroundColor: '#f4f6f8',
        borderBottom: '2px solid #ddd',
        fontWeight: 'bold',
        color: '#555',
    },
    td: {
        padding: '10px',
        borderBottom: '1px solid #eee',
        verticalAlign: 'top',
    },
    input: {
        width: '100%',
        padding: '6px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
    },
    colName: { width: '30%' },
    colUnit: { width: '10%' },
    colQty: { width: '10%' },
    colPrice: { width: '15%' },
    colVat: { width: '10%' },
    colTotal: { width: '15%', textAlign: 'right' },
    colAction: { width: '10%', textAlign: 'center' },
    btnRemove: {
        background: '#ff4d4f',
        color: 'white',
        border: 'none',
        padding: '6px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '0.9rem',
    },
    btnAdd: {
        marginTop: '15px',
        background: '#0056b3',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
};

export default InvoiceItems;
